(() => {
  if (customElements.get('oi-auto-colors')) return;
  const normalize = value => String(value || '').normalize('NFKC').toUpperCase().replace(/[‐‑–—]/g, '-').replace(/\s+/g, '');
  function identify(title) {
    const head = String(title || '').split('|')[0].trim().replace(/[‐‑–—]/g, '-');
    const parts = head.split(/\s+-\s*/);
    if (parts.length !== 2 || !parts[0].trim() || !parts[1].trim()) return null;
    return { key: normalize(parts[0]), label: parts[0].trim(), color: normalize(parts[1]), display: parts[1].trim() };
  }
  const requests = new Map();
  async function getPage(url) {
    const key = url.toString();
    if (!requests.has(key)) {
      const request = fetch(key, { credentials: 'same-origin', signal: AbortSignal.timeout(12000) })
        .then(response => { if (!response.ok) throw new Error('Search unavailable'); return response.text(); })
        .then(html => {
          const document = new DOMParser().parseFromString(html, 'text/html');
          const result = document.querySelector('[data-oi-colors-results]');
          if (!result) throw new Error('Search view unavailable');
          return { pages: Number(result.dataset.pages) || 1, cards: [...result.querySelectorAll('[data-oi-color]')] };
        });
      requests.set(key, request);
      request.catch(() => requests.delete(key));
    }
    return requests.get(key);
  }
  class AutoColors extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.load();
    }
    async load() {
      const current = identify(this.dataset.title);
      if (!current) return;
      try {
        const vendor = normalize(this.dataset.vendor);
        const model = current.label.replace(new RegExp('^' + this.dataset.vendor.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s+', 'i'), '').trim();
        const tokens = model.match(/[A-Za-z0-9]+/g) || [];
        const query = tokens.map(token => token + '*').join(' ');
        if (!query) return;
        const url = new URL(this.dataset.search, location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('type', 'product');
        url.searchParams.set('view', 'oi-auto-colors');
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const found = new Map();
        const show = cards => {
          if (!this.isConnected) return;
          let changed = false;
          for (const card of cards) {
            const identity = identify(card.dataset.title);
            if (!identity || identity.key !== current.key || normalize(card.dataset.vendor) !== vendor || card.dataset.id === this.dataset.id || !card.querySelector('img') || identity.color === current.color || found.has(identity.color)) continue;
            const href = new URL(card.getAttribute('href'), location.origin);
            if (href.origin !== location.origin) continue;
            found.set(identity.color, { card, identity });
            changed = true;
          }
          if (!changed) return;
          const fragment = document.createDocumentFragment();
          const sorted = [...found.values()].sort((a,b) => a.identity.color.localeCompare(b.identity.color, undefined, { numeric: true }));
          for (const {card, identity} of sorted) {
            const li = document.createElement('li');
            const link = card.cloneNode(true);
            const label = document.createElement('span');
            label.className = 'oi-auto-colors__code';
            label.textContent = identity.display;
            link.append(label);
            li.append(link);
            fragment.append(li);
          }
          this.querySelector('ul')?.replaceChildren(fragment);
          this.hidden = false;
        };
        const first = await getPage(url);
        show(first.cards);
        if (first.pages > 1) {
          let nextPage = 2;
          const loadMore = async () => {
            while (nextPage <= first.pages && this.isConnected) {
              const page = nextPage++;
              const pagedUrl = new URL(url);
              pagedUrl.searchParams.set('page', String(page));
              try {
                show((await getPage(pagedUrl)).cards);
              } catch (error) {
                if (window.Shopify?.designMode) console.warn('Optical Incanto: other colours page ' + page, error);
              }
            }
          };
          await Promise.all(Array.from({ length: Math.min(4, first.pages - 1) }, () => loadMore()));
        }
      } catch (error) {
        if (window.Shopify?.designMode) console.warn('Optical Incanto: other colours', error);
      }
    }
  }
  customElements.define('oi-auto-colors', AutoColors);
})();
